import React, { useEffect, useState } from "react"
import { Col, Modal } from "react-bootstrap"

import CRUDField from "../core/genericCRUD/CRUDField"
import FieldSelector from "../core/FieldSelector"
import { useTranslation } from "react-i18next"
import { useFormik } from "formik"
import * as yup from "yup"
import yupTypeValidator from "../../common/YupTypeValidator"
import API from "../../common/API"
import { parsedUser } from "../../common/GetCurrentUser"
import { toast } from "react-toastify"
import LaborAccessRequestDTO from "./LaborAccessRequestDTO"

import VehicleFieldsDTO from "./VehicleFieldsDTO"
import { Base64ToFile } from "../../common/helpers"

const AddEdit = props => {
  // PROPERTIES
  const [record, setRecord] = useState<any>(null)
  const vehicleFields: CRUDField[] = VehicleFieldsDTO
  const fields: CRUDField[] = LaborAccessRequestDTO
  const { t } = useTranslation("global")
  const [formikInitialObject, setFormikInitialObject] = useState<any>({})
  const [validationsSchema, setValidationSchema] =
    useState<yup.ObjectSchema<any>>()
  const [isLoading, setIsLoading] = useState(false)
  const user = parsedUser()
  const formik = useFormik({
    initialValues: formikInitialObject,
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: validationsSchema,
    onSubmit: () => handleSubmit(),
  })
  type YupSchema =
    | yup.StringSchema
    | yup.BooleanSchema
    | yup.NumberSchema
    | yup.DateSchema
  // METHODS

  const fillFormikObject = (record: any) => {
    fields.forEach((item: CRUDField) => {
      if (item && item.name.length > 0) {
        //console.log("field name", item.name, "RecordValue ", record[item.name]);
        if (record && record[item.name]) {
          formik.setFieldValue(item.name, record[item.name])
        }
      }
    })
  }

  const resultadosCedula = async (value: any, field?: string) => {
    // formik.setFieldValue("cedula", value)

    console.log("cedula", value, field)
    let item = value[0]
    if (item) {

      if (field && field === 'responsableId') {

        formik.setFieldValue("responsableName", item.nombres + " " + item.apellido1 + " " + item.apellido2)

      }
      if (field && field === 'secondResponsableId') {

        formik.setFieldValue("secondResponsableName", item.nombres + " " + item.apellido1 + " " + item.apellido2)

      }


      if (item.imagen) {
        let file = Base64ToFile(
          "data:image/jpeg;base64," + item.imagen,
          item.cedula + ".jpg"
        )
        let bodyData = new FormData()
        bodyData.append("path", file)
        const request = await API.postAction(`File/Upload`, bodyData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        if (field === 'secondResponsableId') {
          formik.setFieldValue("secondResponsablePhoto", request.data.response)
        }
        if (field === 'responsableId') {
          formik.setFieldValue("responsablePhoto", request.data.response)
        }
      }
    }
    console.log("relatives", value)
  }

  const prepareFormikObject = () => {
    const initialObject: { [key: string]: string } = {}
    const initialObjectValidation: { [key: string]: YupSchema } = {}

    if (fields) {
      fields.forEach((item: CRUDField) => {
        // if (item.FieldName === "Id" || item.FieldName === "File") return;

        initialObject[item.name] = item.value

        if (item.required) {
          const schema = yupTypeValidator(item)
          if (schema) {
            initialObjectValidation[item.name] = schema
          }
        }
      })
    }

    // formik.initialValues = initialObject;
    setFormikInitialObject(initialObject)
    setValidationSchema(yup.object().shape(initialObjectValidation))
  }
  const resultadosRnc = async (value: any) => {
    // formik.setFieldValue("cedula", value)
    let item = value[0]
    if (item) {
      formik.setFieldValue("companyName", item.nombre)
    }
    console.log("relatives", value)
  }
  const updateField = (fieldName: string, fieldValue: any) => {
    //console.log(fieldName, fieldValue)
    formik.setFieldValue(fieldName, fieldValue)
  }

  const selectMapSearch = async (value: any) => {
    formik.setFieldValue("latitude", value.geometry.location.lat)
    formik.setFieldValue("longitude", value.geometry.location.lng)
    formik.setFieldValue("locationMap", {
      lat: value.geometry.location.lat,
      lng: value.geometry.location.lng,
    })
  }

  const handleSubmit = async (shouldContinue?: boolean | undefined) => {
    try {
      console.log("values to submit", formik.values)

      let query = {}
      fields.forEach((item: CRUDField) => {
        if (item && item.htmlType !== "separator" && item.name.length > 0) {
          query[item.name] = formik.values[item.name] ?? null
        }
      })

      query["locationMap"] = undefined
      query["organizationId"] = user.OrganizationId
      console.log(query)
      setIsLoading(true)
      let request = (await API.postAction(
        `laborAccessRequest/AddEdit`,
        query
      )) as any
      if (request.data.status === "ok") {
        toast.success(t("record saved"))
        if (!shouldContinue) {
          props.toggle()
        } else {
          console.log("the event", request.data)
          fillFormikObject(request.data.response)
        }
      }
    } catch (ex) {
      console.error(ex)
    } finally {
      setIsLoading(false)
    }
  }

  const bindDataRemote = async () => {
    try {
      if (record === null) return
      console.log("bind data remote", record)
      setIsLoading(true)
      let request = await API.getAction(
        "laborAccessRequest/Details?id=" + record.id
      )
      if (request.data.status === "ok") {
        fillFormikObject(request.data.response)

        formik.setFieldValue("locationMap", {
          lat: request.data.response.latitude,
          lng: request.data.response.longitude,
        })
      }
    } catch (e) {
      console.error(e)
    } finally {
      setIsLoading(false)
    }
  }
  // EVENTS
  useEffect(() => {
    prepareFormikObject()
  }, [])

  useEffect(() => {
    setRecord(props.record)
  }, [props.record])

  useEffect(() => {
    console.log("load remote content")
    bindDataRemote()
  }, [record])

  return (
    <>

      <Modal
        show={true}
        onHide={props.toggle}
        size={props.modalSize ? props.modalSize : "lg"}
        className={props.cssClass + " modalRight"}
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("Validación del Representante Laboral")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="flex gap-2 flex-col px-4">
            <div className="row">
              {fields &&
                fields
                  .filter(x => x.htmlType !== "hidden")
                  .map((item, index) => {
                    return (
                      <FieldSelector
                        key={index}
                        model={{
                          ...item,
                          readOnly: props.readOnly ?? false,
                        }}
                        resultadosRnc={resultadosRnc}
                        updateField={updateField}
                        selectMapSearch={selectMapSearch}
                        resultadosCedula={resultadosCedula}
                        obj={formik.values}
                        value={
                          formik.values[item.name as keyof typeof formik.values]
                        }
                        errors={formik.errors}
                      />
                    )
                  })}
              {/* Sub sections  */}
              {/* {formik.values.id && (
                <Col xs={12} className="my-4">
                  <h3>
                    {t("Lista de empleados") ?? ""}
                    <button
                      className="btn btn-sm ms-2 btn-primary"
                      onClick={() => {
                        toggleAddEditEmployee()
                      }}
                    >
                      <i className="fas fa-plus"></i>
                    </button>
                  </h3>
                  <hr />
                  <table className="table table-striped table-bordered">
                    <thead>
                      <tr>
                        <th>{t("Name")}</th>
                        <th>{t("Last Name")}</th>
                        <th>{t("Employment Type")}</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {employees &&
                        employees.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>{item.firstName}</td>
                              <td>{item.lastName}</td>
                              <td>{item.employeeType}</td>
                              <td className="text-end">
                                <button
                                  className="btn btn-primary btn-sm"
                                  onClick={() => {
                                    removeEmployee(item)
                                  }}
                                >
                                  <i className="fas fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          )
                        })}
                    </tbody>
                  </table>
                </Col>
              )} */}

              {/* {formik.values.id && (
                <Col xs={12} className="my-4">
                  <CRUD
                    fields={vehicleFields}
                    isModal={false}
                    id="vehicleForm"
                    // modalSize="sm"
                    cssClass="modalRight"
                    filterOpen={false}
                    readOnly={props.readOnly}
                    // showModal={props.show}
                    // toggleCRUD={props.toggle}
                    title={t("Vehiculo de transporte laboral ") ?? ""}
                    // icon={"fas fa-building"}
                    parentId="laborAccessRequestId"
                    parentValue={formik.values.id}
                    getRecordsMethod="post"
                    getRecordsPath={`laborAccessRequestVehicle/list`}
                    addEditRecordPath={`laborAccessRequestVehicle/AddEdit`}
                    deleteRecordPath="laborAccessRequestVehicle/Delete"
                    fieldsList={[
                      {
                        name: "driverName",
                        title: t("Conductor"),
                        htmlType: "text",
                      },
                      {
                        name: "driverLicense",
                        title: t("Licencia"),
                        htmlType: "text",
                      },
                      {
                        name: "vehiclePlate",
                        title: t("Placa"),
                        htmlType: "text",
                      },
                      {
                        name: "insurancePolicyNumber",
                        title: t("No. de poliza de seguro"),
                        htmlType: "text",
                      },
                    ]}
                  />
                </Col>
              )} */}
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          {!props.readOnly && (
            <div className="modal-action m-0 p-2 ">
              {isLoading && (
                <div className="me-4 d-inline-block">
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              )}
              <button
                className="btn btn-secondary me-2"
                disabled={isLoading}
                onClick={() => props.toggle()}
                type="button"
              >
                {t("Cancel")}
              </button>
              {/* {!formik.values.id && (
                <button
                  className="btn btn-outline-primary text-dark mx-2"
                  disabled={isLoading}
                  onClick={() => handleSubmit(true)}
                  type="button"
                >
                  {t("Guardar y Continuar")}
                </button>
              )} */}
              <button
                className="btn btn-primary text-white"
                disabled={isLoading}
                onClick={() => formik.submitForm()}
                type="button"
              >
                {t("Save")}
              </button>
            </div>
          )}
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default AddEdit
